import { createSlice } from '@reduxjs/toolkit';
import { retrieveVariantProduct } from './actions/retrieveVariantProduct';
const INITIAL_STATE = {
    status: 'pending',
    active: 'variant',
    master: undefined,
    sibling: undefined,
    variant: undefined,
};
export const product = createSlice({
    name: 'product',
    initialState: INITIAL_STATE,
    reducers: {
        removeMasterProduct(state) {
            state.master = undefined;
        },
        removeVariantProduct(state) {
            state.variant = undefined;
        },
        setStatus(state, action) {
            state.status = action.payload;
        },
        setActiveProductType(state, action) {
            state.active = action.payload;
        },
        defineMasterProduct(state, action) {
            state.status = 'fulfilled';
            state.active = action.payload.active;
            state.master = action.payload.item;
            state.variant = action.payload.variant;
            state.sibling = action.payload.sibling;
        },
    },
    extraReducers(builder) {
        builder.addCase(retrieveVariantProduct.fulfilled, (state, action) => {
            state.status = 'fulfilled';
            state.variant = action.payload.item;
            state.sibling = action.payload.sibling;
            state.active = action.payload.active;
        });
    },
});
